const StoreFactory = {
	_stores: {},
	_storePromises: {},

	/**
	 * @private
	 * @param {string} storeName
	 * @returns {Promise<Object>}
	 */
	_getStore: function (storeName) {
		if (this._stores[storeName]) {
			return Promise.resolve(this._stores[storeName]);
		}

		if (!this._storePromises[storeName]) {
			let importPromise;

			switch (storeName) {
				case 'mediathek':
					importPromise = import('./MediathekStore.js');
					break;
				case 'clashOfCams':
					importPromise = import('./ClashOfCamsStore.js');
					break;
				default:
					throw new Error(`Unknown store: ${storeName}`);
			}

			this._storePromises[storeName] = importPromise.then((module) => {
				this._stores[storeName] = module.default;
				return this._stores[storeName];
			});
		}

		return this._storePromises[storeName];
	},

	/**
	 * @returns {Promise<Object>}
	 */
	getMediathekStore: function () {
		return this._getStore('mediathek');
	},

	/**
	 * @returns {Promise<Object>}
	 */
	getClashOfCamsStore: function () {
		return this._getStore('clashOfCams');
	},
};

export default StoreFactory;
